import { observatoryCountries, observatoryNormalizedCountries } from '../lib/countries.js';
import { seriesEsp, seriesEng, seriesId, countriesDataEng, countriesDataEsp, groupsEng, groupsEsp } from './translations/translations_frp_observatorio_internacional.js'
import { translateSeries } from '../lib/translate_series_name.js'
export default class Visualizer {
  series = [];
  charts = [];

  RANGES_DEFAULT = [];
  CHARTS_DEFAULT = [];

  constructor(params) {
    this.charts = params || [];
    this.setDefaults();

    return {
      charts: this.charts.map(x => Object.assign(this.CHARTS_DEFAULT.find(y => y.type == x.type), x)),
      ranges: this.RANGES_DEFAULT,
      endpoints: {
        series: this.series,
        data: {
          build: () => {
            const sql = 'SELECT * FROM observatorio_internacional';
            const gobiertoPath = process.env.GOBIERTO_DATA_URL
            const token = process.env.GOBIERTO_DATA_TOKEN
            const query = `?sql=${sql}&token=${token}`;

            return `${gobiertoPath}/api/v1/data/data.json${query}`;
          },
          parse: data => {
            this.series = translateSeries(this.series, seriesEsp, seriesEng, seriesId, null, null, groupsEsp, groupsEng)
            const series = this.series.map(d => ({
              id: d.id,
              name: d.name,
              group: d.group,
              inverted: d.inverted || false
            }));

            const { data: rawData } = data
            const addGeoItem = rawData.map(({ pais, ano, ...rest }) => {
              return {
                geo_item: pais,
                year: +(ano),
                geo_type: "country",
                ...rest
              }
            })
            addGeoItem.map(d => {
              const { geo_item } = d

              const indexNormalizedCountries = observatoryCountries.findIndex(element => element === geo_item);

              if (indexNormalizedCountries >= 0) {
                d.geo_item = observatoryNormalizedCountries[indexNormalizedCountries]
              }
            })

            addGeoItem.map(d => {
              const { geo_item } = d
              if (d.geo_item) {
                const selectedLanguage = document.documentElement.lang === 'es' ? countriesDataEsp : countriesDataEng
                const indexCountry = countriesDataEsp.findIndex(country => country === geo_item);
                d.geo_item = selectedLanguage[indexCountry]
              }
            })

            // reorder the return data to be grouped by kind of serie
            const groupBySerie = series.map(set =>
              addGeoItem.map(d => ({
                serie: set.id,
                time: new Date(d["year"], 0, 1),
                value: parseFloat(d[set.id]),
                name: set.name,
                geo_item: d.geo_item,
                group: set.group,
                inverted: d.inverted || false
              }))
            );

            const groupMapData = {
              groups: groupBySerie.flat(),
              raw: addGeoItem
            }

            return groupMapData;
          }
        }
      }
    };
  }

  setDefaults = () => {
    const series = [
      {
        "id": "vpibpc",
        "group": "Dinámica del crecimiento económico"
      },
      {
        "id": "titpct",
        "group": "Dinámica del crecimiento económico"
      },
      {
        "id": "tdpct",
        "group": "Dinámica del crecimiento económico",
        "inverted": true
      },
      {
        "id": "tabpct",
        "group": "Dinámica del crecimiento económico"
      },
      {
        "id": "vptrapct",
        "group": "Dinámica del crecimiento económico"
      },
      {
        "id": "prosp",
        "group": "Calidad institucional"
      },
      {
        "id": "perccorr",
        "group": "Calidad institucional"
      },
      {
        "id": "effgov",
        "group": "Calidad institucional"
      },
      {
        "id": "le",
        "group": "Calidad institucional"
      },
      {
        "id": "cd",
        "group": "Calidad institucional"
      },
      {
        "id": "tipc",
        "group": "Dinámica monetaria y de sector exterior",
        "inverted": true
      },
      {
        "id": "tir",
        "group": "Dinámica monetaria y de sector exterior",
        "inverted": true
      },
      {
        "id": "scc",
        "group": "Dinámica monetaria y de sector exterior"
      },
      {
        "id": "vtp",
        "group": "Dinámica monetaria y de sector exterior"
      },
      {
        "id": "cae",
        "group": "Dinámica monetaria y de sector exterior"
      },
      {
        "id": "sp",
        "group": "Dinámica del endeudamiento global"
      },
      {
        "id": "dpub",
        "group": "Dinámica del endeudamiento global",
        "inverted": true
      },
      {
        "id": "dpriv",
        "group": "Dinámica del endeudamiento global",
        "inverted": true
      },
      {
        "id": "piin",
        "group": "Dinámica del endeudamiento global"
      },
      {
        "id": "tipdp",
        "group": "Dinámica del endeudamiento global",
        "inverted": true
      },
      {
        "id": "dext",
        "group": "Dinámica del endeudamiento global",
        "inverted": true
      }
    ];

    if (this.charts[0].group) {
      const arrayOfGroup = this.charts[0].group
      this.series = series.filter((d) => arrayOfGroup.includes(d.group))
    } else {
      this.series = series
    }

    const range = (start, stop, step = 1) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
    this.RANGES_DEFAULT = range(1999, 2023);

    this.CHARTS_DEFAULT = [
      {
        type: "Line",
        btnPlaceholder: "Añadir serie",
        xAxisProp: "time",
        yAxisProp: "value",
        aggregationProp: "serie",
        tooltip: this.tooltipCommon,
        language: 'es',
        bspline: false,
        cache: true,
        ticksXAxis: 30,
        tickFormatY: (...args) => {
          const [d, , , d3] = args;

          return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
        }
      },
      {
        type: "Stacked",
        btnPlaceholder: "Añadir serie",
        xAxisProp: "time",
        yAxisProp: "value",
        aggregationProp: "serie",
        tooltip: this.tooltipCommon,
        language: 'es',
        cache: true,
        ticksXAxis: 30,
        tickFormatY: (...args) => {
          const [d, , , d3] = args;

          return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
        }
      },
        {
          type: "Map",
          mapProperty: "vpibpc",
          mapPropertyInverted: false,
          geoTypeProp: "geo_type",
          geoItemProp: "geo_item",
          titleLegend: "",
          language: 'es',
          timeLine: true
        },
        {
          type: "MapContainer",
          data: "observatorio_internacional",
          mapProperty: "vpibpc",
          mapPropertyInverted: false,
          geoTypeProp: "geo_type",
          geoItemProp: "geo_item",
          geoItemFilter: "country",
          titleLegend: "",
          colors: ['#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8'],
          language: 'es',
          firstYear: 1999,
          pivotTableValue: 'geo_item',
          xAxisProp: "time",
          yAxisProp: "value",
          aggregationProp: "serie",
          tooltip: this.tooltipCommon,
          cache: true,
          hasContainer: true,
          timeLine: true,
          pivotTableSelector: true,
          showScales: false,
          tickFormatY: (...args) => {
            const [d, , , d3] = args;

            return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
          }
        }
    ];
  };
  getScale(key, d3) {
    const scales = {
      linear: d3.scaleLinear(),
      log: d3.scaleLog(),
      pow: d3.scalePow()
    };

    if (scales.hasOwnProperty(key)) {
      return scales[key];
    } else {
      return scales[0];
    }
  }

}
